{
  "audit": {
    "lookup": {
      "label": "Find a record",
      "placeholder": "Reference, e.g. PR-000072",
      "selected": "Selected record",
      "kind": {
        "request": "Purchase request",
        "purchase_order": "Purchase order",
        "rfq": "Enquiry",
        "supplier": "Supplier",
        "catalogue_item": "Catalogue item"
      }
    }
  }
}
